module.exports = __webpack_public_path__ + "static/media/ico_no-internent.ef9d42c4.svg";